export const MENU_ITEM_TYPE_MAIN = 'main'
export const MENU_ITEM_TYPE_LINK = 'link'
export const MENU_ITEM_TYPE_MEGA = 'mega'
export const MENU_ITEM_TYPE_SUB = 'sub'
export const MENU_ITEM_TYPES = [
  MENU_ITEM_TYPE_MAIN,
  MENU_ITEM_TYPE_LINK,
  MENU_ITEM_TYPE_MEGA,
  MENU_ITEM_TYPE_SUB
]
